import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { localStorageEnum } from 'types';
import { useAuthorizationSlice } from '../../slice';
import { selectInitLoaded } from '../../slice/selectors';

interface IProps {
  children: React.ReactChild;
}

const AuthWrapper = ({ children, ...props }: IProps) => {
  const isInitLoaded = useSelector(selectInitLoaded);
  const location = useLocation();
  const history = useHistory();

  const { actions } = useAuthorizationSlice();
  const dispatch = useDispatch();

  // Check token and redirect to protected route  or login page on first load
  useEffect(() => {
    if (isInitLoaded) {
      return;
    }

    if (location.search) {
      const query = new URLSearchParams(location.search);
      const token = query.get('t');
      if (token) {
        localStorage.setItem(localStorageEnum.token, token);
      }
    }

    dispatch(actions.initialLoad());
  }, [location.search, isInitLoaded, actions, dispatch, history]);

  if (!isInitLoaded) {
    return null;
  }

  return <> {children} </>;
};

export default AuthWrapper;
